import { CognitoAuthProvider } from './providers/cognito.js';
import { HttpSessionBroker } from './providers/session.js';
import { ApiClient } from './client/api.js';
import { AuthController } from './controllers/auth-controller.js';
import { renderAuth } from './views/auth-views.js';

/**
 * Boot: wire providers → client → controller → views, then attempt the
 * cookie-backed session restore. Configuration is build-time (Vite env);
 * defaults target deployed dev with the local /session* proxy.
 */

// Per-mode config is COMMITTED CODE, not env files (nothing here is secret,
// and an untracked .env must never decide where session authority goes).
// The build stamps its mode into dist/.build-mode and AppStack refuses a
// wrong-mode artifact, so each hosted origin gets exactly its own config.
// - development: local Vite dev server; /session* rides the same-site proxy.
// - devhost:     https://app-dev.giftmotor.com — same site as api-dev, direct.
// - production:  reserved for the launch cutover (real prod pool/client wiring
//                happens with that PO ruling).
const MODES: Record<string, { apiBase: string; sessionBase: string }> = {
  development: { apiBase: 'https://api-dev.giftmotor.com', sessionBase: '' },
  devhost: {
    apiBase: 'https://api-dev.giftmotor.com',
    sessionBase: 'https://api-dev.giftmotor.com',
  },
};
const modeConfig = MODES[import.meta.env.MODE];
if (!modeConfig) throw new Error(`no app config for build mode '${import.meta.env.MODE}'`);
const { apiBase: API_BASE, sessionBase: SESSION_BASE } = modeConfig;
const USER_POOL_ID = 'us-east-1_GlnXGTmxu';
const CLIENT_ID = '3j841i8nip1o4pmlpig1j8heok';

const root = document.getElementById('app');
if (!root) throw new Error('missing #app root');

const provider = new CognitoAuthProvider(USER_POOL_ID, CLIENT_ID);
const broker = new HttpSessionBroker(SESSION_BASE);
// The client and controller reference each other for session-lost handling;
// the closures only run after both exist.
const api = new ApiClient(API_BASE, broker, () => controller.sessionLost());
const controller = new AuthController(provider, broker, api, (state) =>
  renderAuth(root, state, controller, api),
);

void controller.start();

if ('serviceWorker' in navigator && !import.meta.env.DEV) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js');
  });
}
